import React from "react";
import {Table} from "react-bootstrap";
import AnalysisCard from "./AnalysisCard.jsx";
import YearValueCells from "./YearValueCells.jsx";
import YearHeaderCells from "./YearHeaderCells.jsx";
import SignedPercentValue from "./SignedPercentValue.jsx";
import HeaderWithHelp from "./HeaderWithHelp.jsx";
import {pastYearColumns, referenceLabels} from "./format.js";

/**
 * Jahresvergleich je Produktlinie auf der Kundenseite - schlanker als die
 * Kundenrangliste (kein Plan, keine Abweichungsspalten), weil hier nur ein
 * einzelner Kunde betrachtet wird.
 */
export default function CustomerProductLineTable({productLines, meta, reference}) {
    const mergedYears = {};
    (productLines || []).forEach((row) => Object.assign(mergedYears, row.years));
    const pastYears = pastYearColumns(mergedYears, meta?.current_year);
    const labels = referenceLabels(reference, meta);
    const hideCurrent = labels.current === null;
    const hideHr = labels.hr === null;

    return (
        <AnalysisCard
            title="Jahresvergleich je Produktlinie"
            help="Jahresvergleich je Artikelart und Produktlinie für diesen Kunden, nur Rechnungswerte."
            loading={false}
            error={null}
            empty={(productLines || []).length === 0}
        >
            <div className="table-responsive">
                <Table size="sm" hover className="mb-0 align-middle">
                    <thead>
                        <tr>
                            <th>Type / Artikelart</th>
                            <th>
                                <HeaderWithHelp help="Produktlinie des Artikels laut Artikelstamm.">Produktlinie</HeaderWithHelp>
                            </th>
                            <YearHeaderCells pastYears={pastYears} currentLabel={labels.current} hrLabel={labels.hr} />
                            <th className="text-end va-num-th">
                                <HeaderWithHelp help="Hochrechnung (bzw. Bezugsjahr) gegen den Durchschnitt der vier Jahre davor." placement="left">
                                    {labels.trend}
                                </HeaderWithHelp>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {(productLines || []).map((row) => (
                            <tr key={`${row.article_type}-${row.product_line}`}>
                                <td>{row.article_type}</td>
                                <td>{row.product_line || "Nicht zugeordnet"}</td>
                                <YearValueCells years={row.years} current={row.current} hr={row.hr} pastYears={pastYears} hideCurrent={hideCurrent} hideHr={hideHr} />
                                <td className="text-end text-nowrap"><SignedPercentValue value={row.trend} /></td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
        </AnalysisCard>
    );
}
